<script setup>
import { ref, watch, nextTick } from "vue";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import { useGlobalStore } from "@stores/global";

const globalStore = useGlobalStore();
const trapRef = ref(null);

const { activate, deactivate } = useFocusTrap(trapRef, {
    allowOutsideClick: true,
    escapeDeactivates: false,
});

watch(
    () => globalStore.modal.name,
    async (name) => {
        if (name && name !== "exploreIntro") {
            await nextTick();
            activate();
        } else {
            deactivate();
        }
    },
);
</script>

<template>
    <Teleport to="body">
        <Transition name="modal">
            <div
                v-if="
                    globalStore.modal.name &&
                    globalStore.modal.name !== 'exploreIntro'
                "
                :class="[
                    'modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm',
                    globalStore.modal.fullHeight ? 'p-2 max-lg:p-0' : 'p-2',
                ]"
                @click.self="
                    globalStore.modal.canClose && globalStore.closeModal()
                "
            >
                <div
                    ref="trapRef"
                    :class="[
                        'modal-content flex overflow-y-auto',
                        globalStore.modal.bare ? '' : 'bg-marine-700 p-3',
                        globalStore.modal.fullHeight
                            ? 'max-h-[90svh] max-lg:h-full max-lg:max-h-svh'
                            : 'max-h-[90svh]',
                    ]"
                >
                    <slot />
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<style>
.modal-enter-active,
.modal-leave-active {
    transition:
        opacity 0.25s ease,
        backdrop-filter 0.25s ease;
}
.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
    transition:
        opacity 0.25s ease,
        transform 0.25s ease;
}
.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}
.modal-enter-from .modal-content,
.modal-leave-to .modal-content {
    opacity: 0;
    transform: scale(0.96);
}
</style>
